import { render, staticRenderFns } from "./wait_approve_box.vue?vue&type=template&id=1a6b85d0&scoped=true"
import script from "./wait_approve_box.vue?vue&type=script&lang=js"
export * from "./wait_approve_box.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/wait-approve.scss?vue&type=style&index=0&id=1a6b85d0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b85d0",
  null
  
)

export default component.exports